import React from "react";
import { Link } from "react-router-dom";
// CSS
import styles from "./TabbedView.module.css";
import { ITab } from "../../../Types/ITab";
// Components
import Tab from "./Tab";

type TabbedViewProps = {
  data: ITab[];
  activeTab: ITab;
  activeTabChanged: (tab: ITab) => void;
  disableNavigation?: boolean;
};

const TabbedView = ({
  data,
  activeTab,
  activeTabChanged,
  disableNavigation = false,
}: TabbedViewProps) => {
  return (
    <div className={styles.container}>
      {data.map((item, index) => {
        const tab = (
          <Tab
            key={index}
            title={item.title}
            active={item.title === activeTab.title}
            clickHandler={() => activeTabChanged(item)}
          />
        );

        return disableNavigation ? (
          <div key={index} onClick={() => activeTabChanged(item)}>
            {tab}
          </div>
        ) : (
          <Link
            key={index}
            to={item.url}
            onClick={() => activeTabChanged(item)}
          >
            {tab}
          </Link>
        );
      })}
    </div>
  );
};

export default TabbedView;
